import React from 'react';

export default function CardPanel({ children }) {
  return(
    <div className="row">
      <div className="col s12 m12 l12">
        <div className="card-panel">
          {children}
        </div>
      </div>
    </div>
  );
}
